import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";

export const useAddAreaTemplateModalViewModel = ({
  stateManager,
  closeModal,
  reset,
  getAreaTemplates,
}) => {
  const isLoading = stateManager.isBusy();

  const handleCreateAreaTemplate = (data) => {
    const { id, ...restData } = data;
    const updatedPlanAreas = restData.planAreas.map(({ id, ...restArea }) => {
      return { ...restArea, materials: [] };
    });
    const dataWithoutId = { ...restData, planAreas: updatedPlanAreas };
    delete dataWithoutId.options;

    stateManager.run(async () => {
      const response = await homeService.plans.templates.createAreaTemplate({
        data: dataWithoutId,
        toastMessageConfig: {
          success: {
            text: `Successfully created Area Template ${data.name}.`,
          },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        getAreaTemplates();
        closeModal();
        reset();
      }
    });
  };

  return {
    handleCreateAreaTemplate,
    isLoading,
  };
};
